// extracted by mini-css-extract-plugin
module.exports = {"header":"header-module--header--3A712","list":"header-module--list--20uKA","brand":"header-module--brand--3tjli"};